import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import styled from 'styled-components';
import { KeyRound, Loader2 } from 'lucide-react';
import { StyledButton, AlertBox } from '../main/CommonStyles';

const StyledForm = styled.form`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;
`;

const StyledInput = styled.input`
    padding: 1rem;
    border: 2px solid ${({ theme }) => theme.colors.borderColor};
    border-radius: ${({ theme }) => theme.borderRadius};
    font-size: 1.25rem;
    text-align: center;
    font-weight: 700;
    letter-spacing: 2px;
    font-family: 'Courier New', Courier, monospace;

    &:focus {
        outline: none;
        border-color: ${({ theme }) => theme.colors.primary};
        box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.primaryLightest};
    }
`;

const CodeLoginForm = () => {
    const [accessCode, setAccessCode] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { loginWithCode } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        // Ta funkcja jest wywoływana, gdy formularz jest wysyłany
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            await loginWithCode(accessCode);
            navigate('/app', { replace: true });
        } catch (err) {
            setError(err.response?.data?.message || 'Logowanie kodem nie powiodło się. Sprawdź, czy kod jest poprawny.');
        }
        setLoading(false);
    };

    return (
        <>
            {error && <AlertBox type="error" style={{ marginBottom: '1rem' }}>{error}</AlertBox>}
            <StyledForm onSubmit={handleSubmit}>
                <StyledInput
                    type="text"
                    placeholder="WPISZ KOD"
                    value={accessCode}
                    onChange={(e) => setAccessCode(e.target.value.toUpperCase())}
                    required
                    disabled={loading}
                    aria-label="Kod dostępu"
                />
                <StyledButton type="submit" disabled={loading || !accessCode} style={{ width: '100%', height: '56px', fontSize: '1.2rem' }}>
                    {loading ? <Loader2 className="icon-spin" /> : <KeyRound />}
                    Wejdź
                </StyledButton>
            </StyledForm>
        </>
    );
};

export default CodeLoginForm;